import React, { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import { 
  ExternalLink, 
  Eye, 
  Heart, 
  TrendingUp, 
  ShoppingBag,
  Globe,
  PenTool,
  BarChart2,
  Filter,
  ChevronRight,
  Award,
  Star,
  Users,
  Zap
} from "react-feather";

const styles = {
  section: {
    padding: '120px 0',
    backgroundColor: '#ffffff',
    position: 'relative',
  },
  title: {
    fontSize: '3.5rem',
    fontWeight: '800',
    color: '#1e293b',
    marginBottom: '1rem',
    textAlign: 'center',
  },
  subtitle: {
    fontSize: '1.2rem',
    color: '#64748b',
    textAlign: 'center',
    maxWidth: '700px',
    margin: '0 auto 60px',
    lineHeight: '1.6',
  },
  filterNav: {
    display: 'flex',
    justifyContent: 'center',
    gap: '15px',
    marginBottom: '50px',
    flexWrap: 'wrap',
  },
  filterButton: {
    backgroundColor: '#e2e8f0',
    border: 'none',
    padding: '12px 30px',
    borderRadius: '50px',
    fontSize: '0.95rem',
    fontWeight: '600',
    color: '#64748b',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  filterButtonActive: {
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    boxShadow: '0 4px 15px rgba(59, 130, 246, 0.3)',
  },
  portfolioCard: {
    borderRadius: '20px',
    overflow: 'hidden',
    marginBottom: '30px',
    position: 'relative',
    backgroundColor: '#ffffff',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e2e8f0',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  portfolioCardHover: {
    transform: 'translateY(-15px)',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.15)',
  },
  cardImage: {
    width: '100%',
    height: '250px',
    objectFit: 'cover',
    transition: 'transform 0.6s ease',
  },
  cardImageHover: {
    transform: 'scale(1.05)',
  },
  cardOverlay: {
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '0',
    transition: 'opacity 0.3s ease',
    padding: '30px',
  },
  cardOverlayHover: {
    opacity: '1',
  },
  overlayContent: {
    textAlign: 'center',
    color: '#ffffff',
  },
  cardContent: {
    padding: '25px',
  },
  projectCategory: {
    display: 'inline-block',
    backgroundColor: 'rgba(59, 130, 246, 0.1)',
    color: '#3b82f6',
    padding: '6px 15px',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '600',
    marginBottom: '15px',
  },
  projectTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '10px',
  },
  projectDescription: {
    fontSize: '0.95rem',
    color: '#64748b',
    lineHeight: '1.6',
    marginBottom: '20px',
  },
  projectStats: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '20px',
    borderTop: '1px solid #e2e8f0',
  },
  statItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '0.9rem',
    color: '#64748b',
  },
  viewButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    border: 'none',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    opacity: '0',
    transform: 'translateY(-10px)',
  },
  viewButtonHover: {
    opacity: '1',
    transform: 'translateY(0)',
  },
  likeButton: {
    position: 'absolute',
    top: '80px',
    right: '20px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    border: 'none',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    opacity: '0',
    transform: 'translateY(-10px)',
  },
  likeButtonHover: {
    opacity: '1',
    transform: 'translateY(0)',
  },
  statsSection: {
    backgroundColor: '#f8fafc',
    borderRadius: '25px',
    padding: '60px 40px',
    marginTop: '80px',
    textAlign: 'center',
  },
  statNumber: {
    fontSize: '3.5rem',
    fontWeight: '800',
    color: '#3b82f6',
    marginBottom: '10px',
    lineHeight: '1',
  },
  statLabel: {
    fontSize: '1.1rem',
    color: '#64748b',
    fontWeight: '500',
  },
  ctaSection: {
    textAlign: 'center',
    marginTop: '80px',
  },
  ctaButton: {
    background: 'linear-gradient(45deg, #3b82f6, #8b5cf6)',
    border: 'none',
    color: '#ffffff',
    padding: '18px 45px',
    fontSize: '1.1rem',
    fontWeight: '600',
    borderRadius: '50px',
    transition: 'all 0.3s ease',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
  },
  ctaButtonHover: {
    transform: 'translateY(-3px)',
    boxShadow: '0 15px 30px rgba(59, 130, 246, 0.4)',
  },
};

function Portfolio() {
  const [hoverStates, setHoverStates] = useState({});
  const [activeFilter, setActiveFilter] = useState('all');
  const [likedProjects, setLikedProjects] = useState([]);

  const filters = [
    { id: 'all', label: 'All Projects', icon: <Filter size={16} /> },
    { id: 'web', label: 'Web Design', icon: <Globe size={16} /> },
    { id: 'branding', label: 'Branding', icon: <PenTool size={16} /> },
    { id: 'ecommerce', label: 'E-commerce', icon: <ShoppingBag size={16} /> },
    { id: 'marketing', label: 'Marketing', icon: <BarChart2 size={16} /> },
  ];

  const projects = [
    {
      id: 1,
      title: "EcoStyle Fashion",
      category: "E-commerce",
      type: "ecommerce",
      description: "Complete online fashion store with advanced inventory management and multi-currency payment system.",
      image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      stats: {
        revenue: "+300%",
        traffic: "+450%",
        likes: 234,
      },
      color: '#10b981',
    },
    {
      id: 2,
      title: "TechFlow SaaS Platform",
      category: "Web Application",
      type: "web",
      description: "Enterprise SaaS solution with real-time analytics and collaborative workspace features.",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      stats: {
        revenue: "+500%",
        users: "10K+",
        likes: 189,
      },
      color: '#3b82f6',
    },
    {
      id: 3,
      title: "UrbanBite Restaurant",
      category: "Brand Identity",
      type: "branding",
      description: "Complete brand identity package including logo, packaging, and marketing materials.",
      image: "https://images.unsplash.com/photo-1559925393-8be0ec4767c8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      stats: {
        sales: "+200%",
        recognition: "Award",
        likes: 156,
      },
      color: '#f59e0b',
    },
    {
      id: 4,
      title: "HealthTrack Pro",
      category: "Mobile App",
      type: "web",
      description: "Health and fitness tracking application with AI-powered recommendations.",
      image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      stats: {
        downloads: "50K+",
        rating: "4.9/5",
        likes: 278,
      },
      color: '#8b5cf6',
    },
    {
      id: 5,
      title: "Global Finance Corp",
      category: "Digital Marketing",
      type: "marketing",
      description: "Comprehensive digital marketing campaign generating high-quality leads.",
      image: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      stats: {
        leads: "+800%",
        roi: "12x",
        likes: 198,
      },
      color: '#ef4444',
    },
    {
      id: 6,
      title: "EduLearn Platform",
      category: "Web Design",
      type: "web",
      description: "Interactive e-learning platform with course management and progress tracking.",
      image: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      stats: {
        students: "25K+",
        completion: "92%",
        likes: 312,
      },
      color: '#06b6d4',
    },
  ];

  const filteredProjects = projects.filter(project => 
    activeFilter === 'all' || project.type === activeFilter
  );

  const stats = [
    { number: "500+", label: "Projects Completed", icon: <Award size={24} /> },
    { number: "98%", label: "Client Satisfaction", icon: <Star size={24} /> },
    { number: "150+", label: "Happy Clients", icon: <Users size={24} /> },
    { number: "40%", label: "Average Growth", icon: <TrendingUp size={24} /> },
  ];

  const toggleLike = (projectId) => {
    if (likedProjects.includes(projectId)) {
      setLikedProjects(likedProjects.filter(id => id !== projectId));
    } else {
      setLikedProjects([...likedProjects, projectId]);
    }
  };

  return (
    <section id="portfolio" style={styles.section}>
      <Container>
        {/* Header */}
        <div className="text-center mb-5">
          <div style={{
            display: 'inline-block',
            backgroundColor: 'rgba(59, 130, 246, 0.1)',
            color: '#3b82f6',
            padding: '10px 25px',
            borderRadius: '20px',
            fontSize: '0.95rem',
            fontWeight: '600',
            marginBottom: '20px',
          }}>
            <Zap size={16} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
            Showcase of Excellence
          </div>
          
          <h2 style={styles.title}>
            Our <span style={{ color: '#3b82f6' }}>Portfolio</span>
          </h2>
          
          <p style={styles.subtitle}>
            Explore our featured projects that demonstrate our expertise in creating 
            impactful digital solutions for businesses across various industries.
          </p>
        </div>

        {/* Filter Navigation */}
        <div style={styles.filterNav}>
          {filters.map((filter) => (
            <button
              key={filter.id}
              style={{
                ...styles.filterButton,
                ...(activeFilter === filter.id ? styles.filterButtonActive : {})
              }}
              onClick={() => setActiveFilter(filter.id)}
            >
              {filter.icon}
              {filter.label}
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <Row>
          {filteredProjects.map((project) => (
            <Col lg={4} md={6} key={project.id}>
              <div
                style={{
                  ...styles.portfolioCard,
                  ...(hoverStates[project.id] ? styles.portfolioCardHover : {})
                }}
                onMouseEnter={() => setHoverStates({...hoverStates, [project.id]: true})}
                onMouseLeave={() => setHoverStates({...hoverStates, [project.id]: false})}
              >
                {/* Project Image */}
                <div style={{ position: 'relative', overflow: 'hidden' }}>
                  <img
                    src={project.image}
                    alt={project.title}
                    style={{
                      ...styles.cardImage,
                      ...(hoverStates[project.id] ? styles.cardImageHover : {})
                    }}
                  />
                  
                  {/* Overlay */}
                  <div style={{
                    ...styles.cardOverlay,
                    ...(hoverStates[project.id] ? styles.cardOverlayHover : {})
                  }}>
                    <div style={styles.overlayContent}>
                      <h4 style={{ fontSize: '1.5rem', fontWeight: '700', marginBottom: '15px' }}>
                        {project.title}
                      </h4>
                      <p style={{ fontSize: '1rem', opacity: '0.9' }}>
                        {project.description}
                      </p>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <button
                    style={{
                      ...styles.viewButton,
                      ...(hoverStates[project.id] ? styles.viewButtonHover : {})
                    }}
                    onClick={() => window.open(project.image, '_blank')}
                  >
                    <Eye size={20} color="#3b82f6" />
                  </button>

                  <button
                    style={{
                      ...styles.likeButton,
                      ...(hoverStates[project.id] ? styles.likeButtonHover : {})
                    }}
                    onClick={() => toggleLike(project.id)}
                  >
                    <Heart 
                      size={20} 
                      color={likedProjects.includes(project.id) ? '#ef4444' : '#64748b'}
                      fill={likedProjects.includes(project.id) ? '#ef4444' : 'none'}
                    />
                  </button>
                </div>

                {/* Project Info */}
                <div style={styles.cardContent}>
                  <div style={{...styles.projectCategory, backgroundColor: `${project.color}15`, color: project.color}}>
                    {project.category}
                  </div>
                  
                  <h3 style={styles.projectTitle}>{project.title}</h3>
                  
                  <p style={styles.projectDescription}>
                    {project.description}
                  </p>

                  <div style={styles.projectStats}>
                    <div style={styles.statItem}>
                      <TrendingUp size={16} color={project.color} />
                      <span style={{ color: project.color, fontWeight: '600' }}>
                        {project.stats.revenue || project.stats.downloads || project.stats.sales || project.stats.leads || project.stats.students}
                      </span>
                    </div>
                    
                    <div style={styles.statItem}>
                      <Heart 
                        size={16} 
                        color={likedProjects.includes(project.id) ? '#ef4444' : '#64748b'}
                        fill={likedProjects.includes(project.id) ? '#ef4444' : 'none'}
                      />
                      {project.stats.likes} Likes
                    </div>
                    
                    <div style={styles.statItem}>
                      <ExternalLink size={16} color={project.color} />
                      View
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* Stats Section */}
        <div style={styles.statsSection}>
          <Row>
            {stats.map((stat, index) => (
              <Col md={3} sm={6} key={index} className="mb-4 mb-md-0">
                <div style={{ color: '#3b82f6', marginBottom: '15px' }}>
                  {stat.icon}
                </div>
                <div style={styles.statNumber}>{stat.number}</div>
                <div style={styles.statLabel}>{stat.label}</div>
              </Col>
            ))}
          </Row>
        </div>

        {/* CTA Section */}
        <div style={styles.ctaSection}>
          <h3 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1e293b', marginBottom: '20px' }}>
            Ready to Start Your Project?
          </h3>
          
          <p style={{ fontSize: '1.1rem', color: '#64748b', maxWidth: '600px', margin: '0 auto 30px' }}>
            Let's create something amazing together. Share your vision with us.
          </p>
          
          <button
            style={{
              ...styles.ctaButton,
              ...(hoverStates.cta ? styles.ctaButtonHover : {})
            }}
            onMouseEnter={() => setHoverStates({...hoverStates, cta: true})}
            onMouseLeave={() => setHoverStates({...hoverStates, cta: false})}
          >
            Start Your Project
            <ChevronRight size={20} />
          </button>
        </div>
      </Container>

      {/* Decorative Elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(59, 130, 246, 0.05) 0%, transparent 70%)',
        zIndex: '0',
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '20%',
        right: '5%',
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(16, 185, 129, 0.05) 0%, transparent 70%)',
        zIndex: '0',
      }}></div>

      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          .portfolio-card {
            animation: fadeIn 0.6s ease-out;
            animation-fill-mode: both;
          }
          
          @media (max-width: 768px) {
            .section {
              padding: 60px 0 !important;
            }
            
            .title {
              font-size: 2.5rem !important;
            }
            
            .filter-nav {
              gap: 8px !important;
            }
            
            .filter-button {
              padding: 10px 20px !important;
              font-size: 0.85rem !important;
            }
            
            .stats-section {
              padding: 30px 20px !important;
            }
          }
        `}
      </style>
    </section>
  );
}

export default Portfolio;